<script>
  import { t } from "../i18n.js";
  import SwaggerUI from "../components/SwaggerUI.svelte";
  import ViewCardContainer from "../components/ViewCardContainer.svelte";
  import AlertBox from "../components/common/AlertBox.svelte";
  import { onMount } from "svelte";
  import { startAuth } from "../login.js";
  import CopyToClipboard from "../components/common/CopyToClipboard.svelte";
  import { environment } from "../enviroments/enviroment.js";
  import { getUserInfo } from "../services/tokenService.js";

  const grafanaUrl = environment.grafanaUrl;

  const useCaseGrafanaUrls = {
    1: "/d/foBMc-KVz/kt4-kapy-laskurit?orgId=1&var-mittapiste=Tehdaskatu%20l%C3%A4nteen&var-arvo=countvehicle&from=now-24h&to=now",
    2: "/d/TWP_TMz4z/kt2-mittarin-arvot?orgId=1",
    3: "/d/7WnOxMzVz/kt3-sahkotolpat?orgId=1",
    5: "/d/P9zpzA2Vk/kt5-vilkku?orgId=1&from=now-1m&to=now",
    9: "/d/e81cc340-461c-4d2a-84a3-1f92c2c50596/kt9-pysakointi?orgId=1",
    12: "/d/bf946da2-ba2a-4801-ad93-deb7e9e766d5/kt12-kuopion-pysakointilaitokset?orgId=1",
  };

  const useCasePermissions = {
    1: "kt4",
    2: "kt2",
    3: "kt3",
    5: "kt5",
    // 8: 'kt8',
    9: "kt9",
    12: "kt12",
  };

  let isLoggedIn;
  let accessToken;
  let refreshToken;
  let userInfo;
  let userGroups;
  let permissions = [];
  onMount(() => {
    isLoggedIn = localStorage.getItem("isLoggedIn");
    accessToken = localStorage.getItem("accessToken");
    refreshToken = localStorage.getItem("refreshToken");
    // userInfo = JSON.parse(localStorage.getItem('userInfo'))
    // for (let permission of userInfo.active) {
    //     permissions.push(permission.permissionExternalId)
    // }
    userGroups = JSON.parse(localStorage.getItem("userGroups"));
    if (userGroups) {
      for (let permission of userGroups.active) {
        permissions.push(permission.permissionExternalId);
      }
    }
  });

  const envName = environment.envName;
  const useCase = window.location.href.substring(
    window.location.href.lastIndexOf("/") + 1
  );
  const apiDoc = `${envName}-use-case${useCase}-doc.yml`;
  let selectedTab = "api-description";

  onMount(() => {
    window.scrollTo(0, 0);
  });

  export let name = `datasource.use-case${useCase}-name`;

  function setTabToDescription() {
    selectedTab = "api-description";
  }
  function setTabToData() {
    selectedTab = "api-data";
  }
</script>

<ViewCardContainer pageTitle={$t(name)}>
  {#if useCase === "8"}
    <!-- Users can't see CityBikes Anymore -->
    <p>{$t("datasource.permission-not-found")}</p>
  {:else}
    {#if !isLoggedIn}
      <div class="mb-8">
        <AlertBox>
          <p>
            {$t("datasource.token-notice")}<button
              on:click={startAuth}
              class="text-navy font-semibold"
              >{$t("datasource.token-notice-link")}</button
            >
          </p>
        </AlertBox>
      </div>
    {/if}
    <h2 class="mb-2">{$t("datasource.page-title")}</h2>
    <p class="mb-12">{$t("datasource.page-description")}</p>
    <button
      aria-label={$t("datasource.tab-api-aria")}
      class="{selectedTab === 'api-description'
        ? 'text-navy border-b-4 border-navy'
        : ''} uppercase font-semibold mr-8 mb-10"
      on:click={setTabToDescription}>{$t("datasource.tab-api")}</button
    >
    <button
      aria-label={$t("datasource.tab-data-aria")}
      class="{selectedTab === 'api-data'
        ? 'text-navy border-b-4 border-navy'
        : ''} uppercase font-semibold"
      on:click={setTabToData}>{$t("datasource.tab-data")}</button
    >
    {#if selectedTab === "api-description"}
      {#if isLoggedIn && permissions.includes(useCasePermissions[useCase])}
        <h3 class="mb-2">{$t("datasource.token-title")}</h3>
        <p class="mb-2" style="font-style: italic;">
          {$t("datasource.token-lifetime")}
        </p>
        <CopyToClipboard content={accessToken} componentId={"access"} />
        <h3 class="mb-2">{$t("datasource.refresh-token-title")}</h3>
        <p class="mb-2" style="font-style: italic;">
          {$t("datasource.refresh-token-lifetime")}
        </p>
        <CopyToClipboard content={refreshToken} componentId={"refresh"} />
      {:else if isLoggedIn && !permissions.includes(useCasePermissions[useCase])}
        <!-- HUOM. Voisi tehdä jossain CSS-luokassa. Quick fix -->
        <h2 class="mb-8" style="color: crimson; font-size: larger">
          {$t("datasource.permission-not-found")}
        </h2>
      {/if}
      <h2>{$t("datasource.api-description")}</h2>
      <SwaggerUI doc={apiDoc} />
    {:else if selectedTab === "api-data"}
      <div class="relative overflow-hidden w-full pt-[56.25%]">
        <iframe
          title={$t("datasource.grafana-title")}
          class="absolute inset-0 w-full h-full"
          src="{grafanaUrl}{useCaseGrafanaUrls[useCase]}"
        />
      </div>
    {/if}
  {/if}
</ViewCardContainer>
